export const addMinutesToDateStamp = (dateStamp, minutes) =>
  dateStamp + minutes * 60000;
